import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast-container p-3" }
const _hoisted_2 = {
  id: "notification_toast",
  class: "toast",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true"
}
const _hoisted_3 = { class: "toast-header" }
const _hoisted_4 = { class: "toast-body" }
const _hoisted_5 = { class: "progress progress-sm" }
const _hoisted_6 = {
  ref: "toastProgress",
  class: "progress-bar progress-animation",
  role: "progressbar",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}

import { EventBus, EventBusNames } from "@/utils/EventBus";
import { Toast } from "bootstrap";
import { onMounted, ref, useTemplateRef } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationToast',
  setup(__props) {

const title = ref("");
const message = ref("");
const progress = useTemplateRef<any>("toastProgress");

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_TOAST, (data) => {
    title.value = data.title;
    message.value = data.message;
  });

  const toastTrigger = document.getElementById("notification_toast_button");
  const toast = document.getElementById("notification_toast") as Element;

  if (toastTrigger) {
    const toastBootstrap = Toast.getOrCreateInstance(toast);
    toastTrigger.addEventListener("click", () => toastBootstrap.show());
    progress.value.addEventListener("animationend", () =>
      toastBootstrap.hide()
    );
  }

  // Reset animation
  progress.value.classList.remove("progress-animation");
  void progress.value.offsetWidth; // Trigger reflow
  progress.value.classList.add("progress-animation");
});

return (_ctx: any,_cache: any) => {
  const _component_Typograph = _resolveComponent("Typograph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("button", {
      hidden: "",
      id: "notification_toast_button",
      type: "button",
      "data-bs-toggle": "toast",
      "data-bs-target": "notification_toast"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-check-circle text-primary" }, null, -1)),
          _createVNode(_component_Typograph, {
            variant: 'label',
            class: "me-auto ms-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1)
            ]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "toast",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Typograph, {
            variant: 'label',
            class: "text-muted"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(message.value), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, null, 512)
        ])
      ])
    ])
  ], 64))
}
}

})